import { useMemo } from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import { search, searchQueryKey } from '@/api/kubik/infoportal'
import { TOTAL_ITEMS_PER_PAGE } from '@/pages/Journal/components/JournalBySearch/constants'
import type { IJournalBySearchProps } from '@/pages/Journal/components/JournalBySearch/types'

export const useInfiniteJournalSearch = (props: IJournalBySearchProps) => {
  const { searchText } = props

  const { data, isInitialLoading, isFetching, isError, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryFn: ({ pageParam }) =>
      search({
        query: searchText,
        limit: TOTAL_ITEMS_PER_PAGE,
        offset: pageParam,
      }),
    queryKey: [...searchQueryKey({ query: searchText }), 'journalInfiniteSearch'],
    getNextPageParam: lastPage => {
      if (
        typeof lastPage.data?.pagination.offset === 'number' &&
        lastPage.data.pagination.offset + TOTAL_ITEMS_PER_PAGE >= lastPage.data.pagination.total
      )
        return undefined
      if (!lastPage.data) return undefined

      return lastPage.data.pagination.offset + TOTAL_ITEMS_PER_PAGE
    },
    staleTime: Infinity,
  })

  const searchListData = useMemo(() => data?.pages.map(page => page.data?.publications || []).flat(), [data])

  const getNextPage = () => {
    if (hasNextPage) fetchNextPage()
  }

  return {
    searchListData,
    isLoading: isInitialLoading,
    isFetching,
    isError,
    hasNextPage,
    getNextPage,
  }
}
